export const eachProps = (props, callback) => Object.keys(props).forEach(callback);